import { Grid2 as Grid, Typography } from "@mui/material";
import { useStyles } from "./Invoice.styles";
import { InvoiceHeaderSummaryRowsProps } from "./types";

export const InvoiceHeaderSummaryRows = ({
	storeName,
	supplierName,
	totalPriceInc,
	totalFreightInc,
	totalQty,
	invoiceDate,
}: InvoiceHeaderSummaryRowsProps) => {
	const classes = useStyles();
	const hasFreight = totalFreightInc > 0;

	return (
		<>
			<Grid container size={8} spacing={1}>
				<Grid size={12}>
					<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
						Store
					</Typography>
					<Typography className={classes.value} variant="body2" noWrap>
						{storeName}
					</Typography>
				</Grid>
			</Grid>
			<Grid container size={4} spacing={1}>
				<Grid size={12}>
					{hasFreight ? (
						<>
							<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
								Items Total Inc
							</Typography>
							<Typography className={classes.value} variant="body2">
								{`$${totalPriceInc?.toFixed(2)}`}
							</Typography>
						</>
					) : (
						<>
							<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
								Total Qty
							</Typography>
							<Typography className={classes.value} variant="body2">
								{totalQty}
							</Typography>
						</>
					)}
				</Grid>
			</Grid>
			<Grid container size={8} spacing={1}>
				<Grid size={12}>
					<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
						Supplier
					</Typography>
					<Typography className={classes.value} variant="body2" noWrap>
						{supplierName}
					</Typography>
				</Grid>
			</Grid>
			<Grid container size={4} spacing={1}>
				<Grid size={12}>
					{hasFreight ? (
						<>
							<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
								Freight Cost Inc
							</Typography>
							<Typography className={classes.value} variant="body2">
								{`$${totalFreightInc?.toFixed(2)}`}
							</Typography>
						</>
					) : (
						<>
							<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
								{invoiceDate && "Invoiced Date"}
							</Typography>
							<Typography className={classes.value} variant="body2">
								{invoiceDate && `${invoiceDate.toString().split("T")[0] || ""}`}
							</Typography>
						</>
					)}
				</Grid>
			</Grid>
			{hasFreight && (
				<>
					<Grid container size={8} spacing={1}>
						<Grid size={12}>
							<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
								{invoiceDate && "Invoiced Date"}
							</Typography>
							<Typography className={classes.value} variant="body2">
								{invoiceDate && `${invoiceDate.toString().split("T")[0] || ""}`}
							</Typography>
						</Grid>
					</Grid>
					<Grid container size={4} spacing={1}>
						<Grid size={12}>
							<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
								Total Qty
							</Typography>
							<Typography className={classes.value} variant="body2">
								{totalQty}
							</Typography>
						</Grid>
					</Grid>
				</>
			)}
		</>
	);
};
